// ============================================================
// PORTFOLIO DATA — Edit this file to personalize your portfolio
// ============================================================

export const personalInfo = {
  name: "Safouane Rady",
  tagline: "Full-Stack Developer building useful, scalable web products",
  email: "safouanerady5@gmail.com",
  phone: "+212 656-089067",
  location: "Agadir, Morocco",
  bio: `I'm a full-stack developer focused on building SaaS platforms, dashboards, booking experiences, and e-commerce products with React, Next.js, Node.js, and TypeScript. I enjoy turning real business problems into fast, accessible, and maintainable web applications, from database design and APIs to polished user interfaces. I'm currently open to full-time and freelance opportunities.`,
  resumeUrls: {
    en: process.env.PUBLIC_URL + "/Safouane_Rady_CV_EN.pdf",
    fr: process.env.PUBLIC_URL + "/Safouane_Rady_CV_FR.pdf",
  },
  profileImage: process.env.PUBLIC_URL + "/profile-optimized.jpg",
};

export const socialLinks = {
  github: "https://github.com/SafouaneRady",
  linkedin: "https://www.linkedin.com/in/safouane-rady-b60144348/",
  gmail: "mailto:safouanerady5@gmail.com",
  instagram: "https://www.instagram.com/saf1rady/",
  whatsapp: "https://wa.me/212656089067",
};

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "projects", label: "Projects" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

export const skills = [
  {
    category: "Frontend",
    items: [
      { name: "React", icon: "FaReact" },
      { name: "JavaScript", icon: "SiJavascript" },
      { name: "TypeScript", icon: "SiTypescript" },
      { name: "CSS / SCSS", icon: "FaCss3Alt" },
    ],
  },
  {
    category: "Backend",
    items: [
      { name: "PHP", icon: "SiPhp" },
      { name: "Laravel", icon: "SiLaravel" },
      { name: "Node.js", icon: "FaNodeJs" },
      { name: "Python", icon: "FaPython" },
    ],
  },
  {
    category: "Databases",
    items: [
      { name: "MongoDB", icon: "SiMongodb" },
      { name: "PostgreSQL", icon: "SiPostgresql" },
    ],
  },
  {
    category: "Tools & DevOps",
    items: [
      { name: "Git & GitHub", icon: "FaGitAlt" },
      { name: "Docker", icon: "FaDocker" },
      { name: "Figma", icon: "FaFigma" },
    ],
  },
];

export const funFacts = [
  "☕ Fueled by 3+ cups of coffee daily",
  "💪 Gym addict — never skip leg day",
  "♟️ Chess enthusiast always thinking 3 moves ahead",
  "🎬 Movie buff with an ever-growing watchlist",
];

const projectDisplayOrder = [2, 9, 5, 3, 4, 1, 6, 8, 7];

export const projects = [
  {
    id: 1,
    title: "Sahara Wheels",
    description:
      "Vehicle rental management platform built for Morocco. Consolidates reservations, PDF contract generation, automated WhatsApp/SMS/email notifications, incident tracking with photo documentation, and a live analytics dashboard with KPIs, revenue trends, and occupancy rates — all in one operational system for motorcycle and car rental businesses.",
    techStack: ["Next.js", "TypeScript", "PostgreSQL", "Prisma", "Tailwind CSS", "Twilio"],
    image: process.env.PUBLIC_URL + "/SaharaWheels.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://sahara-wheels.vercel.app/",
    featured: true,
  },
  {
    id: 2,
    title: "LUMÉA",
    description:
      "Full-stack beauty booking platform for bespoke Moroccan beauty rituals in Agadir, allowing customers to discover services, choose a specialist, and reserve appointments through a polished, responsive experience.",
    techStack: ["React", "Node.js", "MongoDB", "Express.js"],
    image: process.env.PUBLIC_URL + "/Lumea.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://lumea-mern.vercel.app/",
    featured: true,
  },
  {
    id: 9,
    title: "Atlas Estates",
    description:
      "A premium real estate showcase for luxury properties across Morocco, featuring destination-led browsing, detailed property pages, responsive search, direct WhatsApp enquiries, and a polished editorial experience designed to turn visitors into qualified leads.",
    techStack: ["Next.js", "TypeScript", "React", "CSS", "Vercel"],
    image: process.env.PUBLIC_URL + "/AtlasEstates.png",
    github: "https://github.com/SafouaneRady/atlas-estates",
    liveDemo: "https://atlas-estates-phi.vercel.app/",
    featured: true,
  },
  {
    id: 3,
    title: "BoviTrack",
    description:
      "Smart cattle herd management platform for farmers and ranchers. A full operational dashboard covering animals, parcels, feed rations, stock, health records, suppliers, and finances — with KPIs (average daily gain, cost/kg), phase breakdowns, active alerts, upcoming treatments, and an AI assistant (BoviAI). Built with secure authentication and a clean, responsive interface.",
    techStack: ["Next.js", "React", "Tailwind CSS"],
    image: process.env.PUBLIC_URL + "/BoviTrack.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://bovitrack.netlify.app/login",
    featured: true,
  },
  {
    id: 4,
    title: "FinanceTracker",
    description:
      "Full-stack personal finance tracker with secure JWT authentication, a dashboard with summary cards and charts, transaction management with filtering and export, monthly category budgeting with progress bars, and deep analytics. Includes dark mode and a fully responsive mobile-first design.",
    techStack: ["React", "Node.js", "MongoDB", "Express.js", "JWT"],
    image: process.env.PUBLIC_URL + "/FinanceTracker.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://finance-tracker-opal-nine.vercel.app/",
    featured: true,
  },
  {
    id: 5,
    title: "Brag — Men's Fashion Store",
    description:
      "Full-stack e-commerce store for premium men's fashion, featuring category-based product browsing, search, shopping cart, user authentication, secure checkout, dark mode, and responsive design.",
    techStack: ["Next.js", "Node.js", "MongoDB", "Express.js", "Stripe"],
    image: process.env.PUBLIC_URL + "/Brag.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://store-eight-rouge.vercel.app/",
    featured: true,
  },
  {
    id: 6,
    title: "StudyFlow Website",
    description:
      "Study management web app with task organization and a built-in Pomodoro timer to improve focus and productivity through a simple and intuitive interface.",
    techStack: ["React", "Node.js", "MongoDB", "Express.js"],
    image: process.env.PUBLIC_URL + "/StudyFlow.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://study-flow-lilac.vercel.app/",
    featured: true,
  },
  {
    id: 8,
    title: "MenuDar",
    description:
      "Multi-tenant SaaS platform for restaurant owners in Morocco to create digital QR-code menus and receive orders online — no app required for customers. Customers scan the QR code on their table, browse the menu in Arabic, French, or English, add items to a cart, and submit the order. The restaurant owner sees the order instantly in their dashboard and receives a WhatsApp notification via Twilio.",
    techStack: ["Next.js 14", "TypeScript", "PostgreSQL", "Prisma", "Tailwind CSS", "Twilio", "next-intl", "Zustand"],
    image: null,
    github: "https://github.com/SafouaneRady",
    liveDemo: null,
    featured: false,
  },
  {
    id: 7,
    title: "CookFlow",
    description:
      "A fun cooking timer app that helps you manage multiple timers for different dishes, keeping your kitchen workflow smooth and on schedule.",
    techStack: ["React"],
    image: process.env.PUBLIC_URL + "/CookFlow.jpg",
    github: "https://github.com/SafouaneRady",
    liveDemo: "https://cookflow-brown.vercel.app/",
    featured: false,
  },
].sort(
  (projectA, projectB) =>
    projectDisplayOrder.indexOf(projectA.id) -
    projectDisplayOrder.indexOf(projectB.id)
);

export const experiences = [
  {
    id: 1,
    type: "education",
    title: "Baccalauréat",
    organization: "Lycée Qalb Alhikma",
    location: "Agadir, Morocco",
    startDate: "Sep 2018",
    endDate: "Jun 2019",
    description:
      "Completed high school with a focus on sciences. Developed strong analytical and problem-solving skills that laid the foundation for a career in tech.",
    technologies: ["Mathematics", "Physics", "French", "Arabic"],
  },
  {
    id: 2,
    type: "education",
    title: "Undergraduate Studies in Economics",
    organization: "Université Ibn Zohr",
    location: "Agadir, Morocco",
    startDate: "Sep 2019",
    endDate: "2021",
    description:
      "Studied economics and management, developing a solid foundation in analytical thinking, financial principles, and economic markets.",
    technologies: ["Economics", "Management", "Statistics", "Data Analysis"],
  },
  {
    id: 3,
    type: "education",
    title: "Digital Development Diploma",
    organization: "CMC Agadir",
    location: "Agadir, Morocco",
    startDate: "Sep 2024",
    endDate: "July 2026",
    description:
      "Specialized in full-stack web development. Built multiple projects using React, Laravel, JavaScript, and SQL/NOSQL. Gained hands-on experience with modern development workflows and version control.",
    technologies: ["React", "Laravel", "JavaScript", "SQL", "HTML/CSS"],
  },
  {
    id: 4,
    type: "work",
    title: "Full-Stack Developer Intern",
    organization: "Media Leo Tech",
    location: "Agadir, Morocco — On-site",
    startDate: "May 2026",
    endDate: "Jun 2026",
    description:
      "Completed a two-month internship working with a team to build a qualified-leads acquisition system using React, Next.js, Node.js, and Express.js. Also contributed to two e-commerce websites built with WordPress, creating responsive, user-friendly experiences and delivering production-ready features.",
    technologies: ["React", "Next.js", "Node.js", "Express.js", "WordPress", "JavaScript", "HTML/CSS"],
  },
];
